"use client";
import { jsx } from "react/jsx-runtime";
import { Table } from "@mantine/core";
import { useMemo, Children, isValidElement, cloneElement } from "react";
import TableTdWrapper from "./TableTdWrapper.js";
const useCustomHeaders = (children) => useMemo(() => {
  if (!children) return null;
  const headers = [];
  Children.forEach(children, (child) => {
    if (isValidElement(child) && child.type === Table.Thead) {
      Children.forEach(child.props.children, (row) => {
        if (isValidElement(row) && row.type === Table.Tr) {
          Children.forEach(row.props.children, (cell) => {
            if (isValidElement(cell) && cell.type === Table.Th) {
              headers.push(cell.props.children);
            }
          });
        }
      });
    }
  });
  return headers;
}, [children]);
const useGeneratedHeaders = (items, children) => useMemo(() => {
  if (Array.isArray(items) && items.length > 0 && !children) {
    return Object.keys(items[0] || {});
  }
  return null;
}, [items, children]);
const renderChildrenWithLabels = (nodes, headers, hideCardLabels) => {
  if (!headers) return nodes;
  return Children.map(nodes, (child) => {
    if (isValidElement(child) && child.type === Table.Tbody) {
      return cloneElement(
        child,
        {},
        Children.map(child.props.children, (row) => {
          if (isValidElement(row) && row.type === Table.Tr) {
            const newChildren = Children.map(
              row.props.children,
              (cell, colIndex) => {
                if (isValidElement(cell) && cell.type === Table.Td) {
                  return /* @__PURE__ */ jsx(TableTdWrapper, { header: headers[colIndex], hideCardLabels, children: cell.props.children });
                }
                return cell;
              }
            ) || [];
            return cloneElement(row, {}, ...newChildren);
          }
          return row;
        })
      );
    }
    return child;
  });
};
export {
  renderChildrenWithLabels,
  useCustomHeaders,
  useGeneratedHeaders
};
